// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectCompaniesInStore,
  selectCompaniesPageLoading,
  selectCompaniesShowInitWaitingMessage,
} from '../_selectors/company.selectors';

export class CompaniesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectCompaniesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectCompaniesShowInitWaitingMessage));

    this.store.pipe(select(selectCompaniesInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
